import React from "react";
import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import {
  currencyFormatter,
  toAbsoluteUrl
} from "../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import { BlockOrg } from "../../../../RoleChecker";

export default function ProjectBalance({
  projectBalance,
  totalProjectIncome,
  totalProjectExpense
}) {
  return (
    <>
      <Card>
        <CardHeader title="Sisa Dana Project" />
        <CardBody>
          <Table>
            <thead>
              <tr>
                <th>Dana Penerimaan</th>
                <th>Dana Penyaluran</th>
                <th>Sisa Dana</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{currencyFormatter(totalProjectIncome)}</td>
                <td>{currencyFormatter(totalProjectExpense)}</td>
                <td>{currencyFormatter(projectBalance)}</td>
              </tr>
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
}
